import { Box, Grid } from '@mui/material'

import RemittancePanel from './RemittancePanel/RemittancePanel'


const AccountPayableDocumentsRemittanceAdviceTab = () => {
  return (
    <Box>
      <Grid container spacing={2} mt={1} justifyContent='center'>
        <Grid item xs={6}>
          <RemittancePanel />
        </Grid>
      </Grid>
    </Box>
  )
}

export default AccountPayableDocumentsRemittanceAdviceTab